var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.167 1.333A6.54 6.54 0 003.18 3.64l-.907-.807a.667.667 0 00-1.106.5V6a.667.667 0 00.666.667h3a.667.667 0 00.44-1.167l-1.1-.98a5.24 5.24 0 014-1.853A5.334 5.334 0 113.147 9.78a.667.667 0 00-1.26.44 6.667 6.667 0 106.28-8.887z",
    fill: "#042A2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.667 10.667a.667.667 0 01-.4-.134l-2.667-2A.667.667 0 017.333 8V5.333a.667.667 0 111.334 0v2.334l2.4 1.8a.666.666 0 01-.4 1.2z",
    fill: "#042A2A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIcon);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/historyIcon.d88d09b6.svg";
export { MemoForwardRef as ReactComponent };